import { IconProps } from '../types';

export const CheckIcon = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="#008743"
      d="m6.666 10.115 6.129-6.129.943.943L6.666 12 2.424 7.758l.943-.943 3.3 3.3Z"
    />
  </svg>
);
